const expectedErrorMessages = [
	'Grabbed context does not meet minimum context requirements',
	'Context size too large',
];

export const isExpectedError = (error: unknown) => {
	const message = error instanceof Error ? error.message : '';
	return expectedErrorMessages.some((expectedMessage) => message.includes(expectedMessage));
};
